$('.tour-hero__read-more').click(function () {
    $(this).siblings('.tour-hero__text').toggleClass('open');
    $('.tour-hero__text-container').toggleClass('open');
});
$(window).load(function () {
    if ($('.tour-hero__text').outerHeight() > 450) {
        $('.tour-hero__text').removeClass('open');
        $('.tour-hero__read-more').show();
    }
})


// WEBPACK FOOTER //
// ./scripts/modules/tours-archive.js